import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../context/GlobalContext';
import * as actionType from "../context/actions";
import ExpenseTableDataLayer from './ExpenseTableDataLayer';
import { Languages } from '../Utils/Languages';
import { FreePlanLimitReachedModal } from './FreePlanLimitReached';
import BusinessDropdown from './child/BusinessDropdown';

const ExpenseListLayer = ({ businessData = [], expenseData }) => {
    const { state, dispatch } = useContext(ConfigContext);
    const navigate = useNavigate();
    const [selectedBusiness, setSelectedBusiness] = useState("null");
    const [isDisplayFreePlanReachedModel, setIsDisplayFreePlanReachedModel] = useState(false);

    // ================= PLAN CONFIG =================
    const starterPlanName = process.env.REACT_APP_STARTER_PLAN_NAME;
    const professionalPlanName = process.env.REACT_APP_PROFESSIONAL_PLAN_NAME;
    const agencyPlanName = process.env.REACT_APP_AGENCY_PLAN_NAME;

    const userPlanName =
        state?.PAYMENT?.[state?.PAYMENT?.length - 1]?.planName || "Free Plan";

    const isFreePlan = userPlanName === "Free Plan";
    const isStarterPlan = userPlanName === starterPlanName;
    const isProfessionalPlan = userPlanName === professionalPlanName;
    const isAgencyPlan = userPlanName === agencyPlanName;
    // =================================================

    const sortedBusinesses = [...businessData].sort(
        (a, b) => Number(b.creationDate) - Number(a.creationDate)
    );

    // ===========================
    // BUSINESS ACCESS LIMIT
    // ===========================
    let allowedBusinessCount = 1; // Free & Starter

    if (isProfessionalPlan) {
        allowedBusinessCount = 3;
    }

    if (isAgencyPlan) {
        allowedBusinessCount = sortedBusinesses.length;
    }

    const ownBusinesses = sortedBusinesses.filter(b => !b.isShared);
    const sharedBusinesses = sortedBusinesses.filter(b => b.isShared);

    const allowedOwnIds = ownBusinesses
        .slice(-allowedBusinessCount)
        .map(b => String(b.companyId));
    const sharedIds = sharedBusinesses.map(b => String(b.companyId));

    const allAllowedIds = [...allowedOwnIds, ...sharedIds];

    const filteredExpenseData = (expenseData || []).filter(item =>
        allAllowedIds.includes(String(item.companyId))
    );

    useEffect(() => {
        const selected =
            businessData?.find(b => b.companyId == state?.SELECTEDBUSINESS)?.companyId ||
            sortedBusinesses[0]?.companyId;

        setSelectedBusiness(selected);
        dispatch({ type: actionType.SELECTEDBUSINESS, payload: selected });
    }, [dispatch, businessData, state?.SELECTEDBUSINESS]);

    const handleSelection = (businessId) => {
        setSelectedBusiness(businessId);
        dispatch({ type: actionType.SELECTEDBUSINESS, payload: businessId });
    };

    return (
        <div className="card basic-data-table">
            <div className="card-header d-flex justify-content-between">

                <BusinessDropdown
                    businesses={sortedBusinesses}
                    selectedCompanyId={state?.SELECTEDBUSINESS}
                    onBusinessChange={handleSelection}
                    onPricingNavigate={() => navigate("/pricing")}
                    showAllOption={true}
                    isAllowedCheck={(business) => {
                        if (business === "null") return isAgencyPlan;

                        const ownBusinesses = sortedBusinesses.filter(b => !b.isShared);
                        const allowedOwnIds = ownBusinesses
                            .slice(-allowedBusinessCount)
                            .map(b => b.companyId);

                        return (
                            business.isShared ||
                            isAgencyPlan ||
                            allowedOwnIds.includes(business.companyId)
                        );
                    }}
                />

                {/* ================= ADD EXPENSE BUTTON ================= */}
                <div>
                    <button
                        onClick={() => {
                            if (!state?.USERID) {
                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                return;
                            }
                            if (state?.BUSINESSES?.length > 0) {
                                navigate("/expense-add");
                            } else {
                                navigate("/business-add");
                            }
                        }}
                        className="btn btn-primary-600 bg-primary border-primary px-18 py-11 d-flex align-items-center"
                    >
                        <i className="ri-add-line me-2" />
                        {Languages[state?.LANGUAGE]?.Add_expense}
                    </button>
                </div>

            </div>

            <FreePlanLimitReachedModal
                isOpen={isDisplayFreePlanReachedModel}
                onClose={() => setIsDisplayFreePlanReachedModel(false)}
                limit={10}
                type={"expense"}
            />

            {/* ================= TABLE ================= */}
            <ExpenseTableDataLayer
                ExpenseData={filteredExpenseData}
                selectedBusiness={selectedBusiness}
            />
        </div>
    );
};

export default ExpenseListLayer;
